import { useTheme } from "next-themes"
import { useIsMobile } from "@/hooks/use-mobile"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()
  const isMobile = useIsMobile()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position={isMobile ? "top-center" : "bottom-left"}
      toastOptions={{
        style: {
          border: '2px solid transparent',
          background: 'linear-gradient(hsl(var(--background)), hsl(var(--background))) padding-box, var(--gradient-lime) border-box',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:shadow-lg font-sans py-6",
          title: "group-[.toast]:text-[#4a7c0f] font-bold",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton: "group-[.toast]:bg-white group-[.toast]:text-black group-[.toast]:border-border hover:group-[.toast]:bg-white/90",
        },
      }}
      icons={{
        success: <></>,
        error: <></>,
        info: <></>,
        warning: <></>,
      }}
      duration={3000}
      dir="rtl"
      richColors
      closeButton
      {...props}
    />
  )
}

export { Toaster, toast }
